<template>
    <div>
        <img
            class="icon search-icon"
            :class="{ active: searchActive }"
            @click="toggleSearch"
            v-if="showSearch && !searchActive"
            src="~@/assets/icons/search-inactive/search-dark-green-outline@3x.svg"
        />
        <img
            class="icon search-icon active"
            @click="toggleSearch"
            v-if="showSearch && searchActive"
            src="~@/assets/icons/search-active/search-dark-green-outline@3x.svg"
        />
        <div class="form" v-if="searchActive">
            <div class="formGroup">
                <!-- <label for="filter">Search</label> -->
                <input
                    type="text"
                    v-model="filter"
                    id="filter"
                    placeholder="Search Players..."
                    ref="filterfield"
                    v-on:keyup.enter="$event.target.blur()"
                />
                <img
                    class="icon delete-icon"
                    src="~@/assets/icons/delete.svg"
                    @click="clearFilter"
                    v-if="this.filter"
                />
            </div>
        </div>
        <ul class="playerList" :class="{ isPending: pending }">
            <player-item
                v-for="player in filteredPlayers"
                :key="player.id"
                :player="player"
                :pending="pending"
            />
        </ul>
    </div>
</template>

<script>
import PlayerItem from "@/components/Pro/Player/player-item";
export default {
    name: "player-list",
    components: {
        PlayerItem,
    },
    data() {
        return {
            filter: "",
            searchActive: false,
        };
    },
    props: {
        pending: {
            type: Boolean,
            required: false,
        },
        players: {
            type: Array,
            required: true,
        },
        showSearch: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    computed: {
        filteredPlayers() {
            if (!this.filter) {
                return this.players;
            }
            return this.players.filter((player) => {
                return (
                    player.first_name.toLowerCase().includes(this.filter.toLowerCase()) ||
                    player.last_name.toLowerCase().includes(this.filter.toLowerCase())
                );
            });
        },
    },
    methods: {
        clearFilter() {
            this.filter = "";
        },
        toggleSearch() {
            this.searchActive = !this.searchActive;
            this.filter = "";
            if (this.searchActive) {
                this.$nextTick(() => {
                    this.$refs.filterfield.focus();
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.playerList {
    margin-bottom: 30px;
}

.search-icon {
    position: absolute;
    top: 30px;
    right: 30px;
    cursor: pointer;
    color: #0f0;
    &.active {
        color: #f90;
    }
}

.formGroup {
    margin-bottom: 20px;
    position: relative;
    .delete-icon {
        cursor: pointer;
        position: absolute;
        right: 15px;
        top: 16px;
        width: 20px;
    }
    label {
        display: block;
        color: #939a93;
    }
    input {
        background: #bbf8e0;
        color: #267962;
        border-radius: 12px;
        width: 100%;
        font-size: 14px;
        border: 0px;
        padding: 15px 20px;
        font-family: canada-type-gibson, sans-serif;
        &:focus {
            outline: 0;
        }
    }
}
</style>
